<template>
  <div class="container">
    <title>Shortlist</title>

    <div class="row">
      <div class="col-lg-1"></div>
      <div class="col-lg-5 col-xs-12 p-2 pt-4">
        <a href="https://jovool.com">
          <img src="/images/Jovool_logo.png" />
        </a>
      </div>

      <div
        style="text-align: right"
        class="pt-4 col-lg-5 col-xs-12"
      >
        <h1 class="color-primary">SHORTLIST {{ job.title }}</h1>
      </div>
      <div class="col-lg-1"></div>
    </div>
    <div class="row">
      <div class="col-lg-1 col-xs-12 col-sm-12"></div>
      <div class="col-lg-10 col-xs-12 col-sm-12 mt-4">
        <div class="table-responsive">
          <table class="table_jovool mt-3">
            <thead class="headerTable">
              <tr class="center">
                <td>IMAGEM</td>
                <td>NOME</td>
                <td>SALÁRIO</td>
                <td></td>
                <td>PERCENTUAL DE ACERTO</td>
                <td>AVALIAÇÃO POR COMPETÊNCIA</td>
                <td>SCORE</td>
                <td>DATA</td>
                <td></td>
                <td v-if="recruiter"></td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(apply, index) in applies"
                :key="apply.id"
                class="center"
              >
                <td>
                  <div class="avatar_thumb pointer">
                    <img
                      @click="show(apply.uid, apply.candidate_uid, index)"
                      :src="apply.image || '/images/avatar.png'"
                    />
                  </div>
                </td>
                <td class="pt-4">{{ apply.name }}</td>
                <td class="pt-4">
                  {{ applyRemuneration(apply.remuneration) }}
                </td>
                <td>
                  <AvaliationLike
                    :recruiter="recruiter"
                    :apply_id="apply.uid"
                    :job_id="apply.job_id"
                    :like_avaliation="apply.like_avaliation"
                    :like_candidate="apply.like_candidate"
                    :star_candidate="apply.star_candidate"
                    :deslike_candidate="apply.deslike_candidate"
                  />
                </td>
                <td class="center">
                  {{ hitsPercentage(apply) }}
                </td>
                <td class="center">
                  {{
                    apply.skills_score
                      ? apply.skills_score.toFixed(2) + "%"
                      : "Não avaliado(a)"
                  }}
                </td>
                <td>
                  <StarRating
                    class="center ajust_star"
                    active-color="#9472F8"
                    :read-only="true"
                    :rating="apply.rating_agg"
                    v-bind:max-rating="5"
                    v-bind:star-size="20"
                  ></StarRating>
                </td>

                <td class="pt-4">
                  {{ formattedDate(apply.created_at) }}
                </td>

                <td class="pt-4">
                  <font-awesome-icon
                    :icon="['fas', 'file-alt']"
                    class="f18 color-primary pointer"
                    @click="show(apply.uid, apply.candidate_uid, index)"
                  />
                </td>
                <td
                  class="pt-4"
                  v-if="recruiter"
                >
                  <font-awesome-icon
                    class="f18 color-red pointer"
                    @click="removeCandidate(apply.uid)"
                    icon="times"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <div>
            <a
              class="btn btn-success mt-3 right"
              :href='"/shortlist_managers/export/"+shortlist_uid+".csv?account_uid=" + account_uid'
              target="_blank"
            >
              Download Csv
            </a>
          </div>
        </div>
        <div class="pt-5 mt-5">
          <div
            style="width: 210px"
            class="right"
          >
            <p class="f12 mb-0 pb-0">RESPONSÁVEL:</p>

            <p class="mb-0 pb-0">
              <b>{{ responsible_recruiter.name }}</b>
            </p>
            <p class="mb-0 pb-0">{{ responsible_recruiter.email }}</p>
            <p class="mb-0 pb-0">{{ responsible_recruiter.mobile_phone }}</p>
          </div>
          <textarea
            v-model="comment"
            rows="6"
            class="form-control"
            placeholder="ADICIONE UMA NOTE GERAL SOBRE A SHORTLIST"
          ></textarea>
          <button
            @click="sendComment"
            type="button"
            class="mt-2 mb-3 right btn btn-primary"
          >
            <font-awesome-icon
              :icon="['fas', 'envelope']"
              class="mr-2"
            />ENVIAR
            COMENTÁRIO
          </button>
        </div>
      </div>
      <div class="col-lg-1 col-xs-1"></div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import StarRating from "vue-star-rating";
import ApplyShow from "@/Recruiters/Applies/Show.vue";
import AvaliationLike from "@/ShortlistManagers/AvaliationLike.vue";
export default {
  components: { StarRating, AvaliationLike },
  props: [
    "applies",
    "job",
    "recruiter",
    "recruiter_id",
    "manager_id",
    "shortlist_uid",
    "account_uid",
    "responsible_recruiter",
  ],
  data: () => ({
    status: ["Não avaliado", "Visualizado", "Avaliado"],
    comment: "",
  }),
  methods: {
    applyRemuneration(remuneration) {
      if (!remuneration) return "Não informado";

      return (
        "R$ " +
        new Intl.NumberFormat("de-DE", {
          style: "currency",
          currency: "BRL",
        })
          .format(remuneration)
          .replace("R$", "")
          .trim()
      );
    },
    haveRightAnswer(question) {
      let excluded_types = [0, 1, 4];
      if (excluded_types.includes(question.response_type)) return false;

      let choices = question.choices;
      if (choices.correctAnswer && choices.correctAnswer != "any") return true;

      if (question.response_type == 2) {
        let rightOptions = choices.options.filter((el) => el.rightAnswer);

        return (
          rightOptions.length > 0 &&
          rightOptions.length != choices.options.length
        );
      }

      return false;
    },
    hitsPercentage(apply) {
      let questions_count = this.job.questions.filter((question) =>
        this.haveRightAnswer(question)
      ).length;

      let percentage = Math.floor((apply.point * 100) / questions_count);

      if (questions_count == 0 || apply.answers.length == 0) {
        return "NÃO APLICÁVEL";
      }
      percentage = `${apply.answers_percentage ?? 'NÃO POSSUI PORCENTAGEM'}`
      apply.hitsPercentage = `${apply.answers_percentage ?? 'NÃO POSSUI PORCENTAGEM'}`;
      return `${percentage} %`;
    },
    sendComment() {
      if (this.comment == "") {
        this.$toast.error("Digite uma mensagem para enviar um comentário");
        return;
      }

      let conf = confirm("Tem certeza que deseja enviar esse comentário?");
      if (!conf) return;

      axios
        .post(`/shortlist_comments/${this.shortlist_uid}/${this.account_uid}`, {
          comments: {
            recruiter_id: 0,
            manager_id: 0,
            comment: this.comment,
          },
        })
        .then((response) => {
          this.$toast.success("Comentário adicionado com sucesso");
          this.comment = "";
        });
    },
    formattedDate(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    show(apply_id, candidate_id, index) {
      this.$modal.show(
        ApplyShow,
        {
          index: index,
          applies: this.applies,
          job_id: this.job.uid,
          apply_id: apply_id,
          candidate_id: candidate_id,
          user_manager: true,
          job_name: this.job.title,
          is_recruiter: this.recruiter,
          shortlist_uid: this.shortlist_uid,
          recruiter_id: this.recruiter_id,
          manager_id: this.manager_id,
          account_uid: this.account_uid,
          hitsPercentage: this.applies[index].hitsPercentage,
        },
        {
          width: "85%",
          height: "auto",
          scrollable: true,
        },
        {
          "before-close": (event) => {
            this.$inertia.reload({
              method: "get",
              data: {},
              preserveState: false,
              preserveScroll: false,
              only: [],
            });
          },
        }
      );
    },
    removeCandidate(uid) {
      if (!this.recruiter) return;

      let conf = confirm(
        "Tem certeza que deseja excluir esse candidato(a) da shortlist?"
      );
      if (!conf) return;
      axios
        .delete(`/shortlist_manger/${this.shortlist_uid}/candidate/${uid}/`)
        .then((response) => {
          location.reload();
        });
    },
  },
};
</script>
